import { PixKeyType } from '../../models/key-type.enum';
import { ETipoAgenteSaquetroco, ETipoOperacao } from '../../models/qr-code-return.model';
import { TipoIniciacaoTransferencia } from '../../models/tipo-iniciacao-transacao.enum';

export class PixWithdrawChangeRequestModel {
		numeroContaBeneficiario: string;
		tipoContaBeneficiario: string;
		agenciaBeneficiario: number;
		tipoAgente: ETipoAgenteSaquetroco;
		valorTroco: number;
		descricao: string;
		documentoBeneficiario: string;
		codigoFimAFim: string;
		tipoIniciacao: ETipoIniciacao;
		tipoIniciacaoTransferencia: TipoIniciacaoTransferencia;
		ispbCodigo: string;
		ispbFornecedor: string;
		chavePix: FiltroChavePixModel;
		nomeBeneficiario: string;
		tipoOperacao: ETipoOperacao;
		numeroOrigem: number;
		valorCompra: number;
		codigoRequisicao: string;
		codigoQrCode: string;
		valor: number;
		valorSaque: number;
}

export class FiltroChavePixModel {
	codigo?: string;
	tipoChave?: PixKeyType;
}

export enum ETipoIniciacao {
	CHAVE_PIX = 'CHAVE_PIX',
	QRCODE_DINAMICO = 'QRCODE_DINAMICO',
	QRCODE_ESTATICO = 'QRCODE_ESTATICO',
	SERVICO_INICIALIZACAO_PGTO = 'SERVICO_INICIALIZACAO_PGTO',
	NAO_INFORMADO = 'NAO_INFORMADO'
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/withdraw-change/models/pix-withdraw-change-request.model.ts